{
  "meta": {
    "compound_map": {
      "adult_family_members": "household_size",
      "child_family_members": "household_size",
      "senior_family_members": "household_size",
      "emergency_contact_name": "emergency_contact",
      "emergency_contact_phone": "emergency_contact",
      "pick_up_name": "food_pickup",
      "pick_up_phone": "food_pickup"
    }
  },
  "questions": [
    {
      "question_uuid": "food_preparation",
      "type": "boolean",
      "label": "custom_field_food_preparation",
      "options": [
        {
          "label": "can_prepare_food",
          "value": 1
        },
        {
          "label": "cannot_prepare_food",
          "value": 0
        }
      ]
    },
    {
      "question_uuid": "country_of_birth",
      "type": "country",
      "label": "country_of_birth"
    },
    {
      "type": "select_one",
      "label": "gender",
      "question_uuid": "gender",
      "options": [
        {
          "label": "gender_option_female",
          "value": "female"
        },
        {
          "label": "gender_option_male",
          "value": "male"
        },
        {
          "label": "gender_option_nonconf",
          "value": "nonconf"
        }
      ]
    },
    {
      "question_uuid": "household_size",
      "type": "compound",
      "label": "household_size",
      "questions": [
        {
          "question_uuid": "adult_family_members",
          "type": "number",
          "label": "fragment_registration_family_textview_adults",
          "validations": [
            {
              "name": "min",
              "argument": 0,
              "error_label": "aiq_validation_error_min_adult_family_members"
            },
            {
              "name": "max",
              "argument": 10,
              "error_label": "aiq_validation_error_max_adult_family_members"
            }
          ]
        },
        {
          "question_uuid": "child_family_members",
          "type": "number",
          "label": "fragment_registration_family_textview_children",
          "validations": [
            {
              "name": "min",
              "argument": 0,
              "error_label": "aiq_validation_error_min_child_family_members"
            },
            {
              "name": "max",
              "argument": 10,
              "error_label": "aiq_validation_error_max_child_family_members"
            }
          ]
        },
        {
          "question_uuid": "senior_family_members",
          "type": "number",
          "label": "fragment_registration_family_textview_seniors",
          "validations": [
            {
              "name": "min",
              "argument": 0,
              "error_label": "aiq_validation_error_min_senior_family_members"
            },
            {
              "name": "max",
              "argument": 10,
              "error_label": "aiq_validation_error_max_senior_family_members"
            }
          ]
        }
      ]
    },
    {
      "question_uuid": "emergency_contact",
      "type": "compound",
      "label": "emergency_contact",
      "questions": [
        {
          "type": "text",
          "label": "fragment_profile_edittext_emergencyname",
          "validations": [
            {
              "name": "required",
              "argument": true,
              "error_label": "aiq_validation_error_required_emergency_contact"
            }
          ],
          "question_uuid": "emergency_contact_name"
        },
        {
          "type": "telephone_us",
          "label": "fragment_profile_edittext_emergencyphone",
          "question_uuid": "emergency_contact_phone"
        }
      ]
    },
    {
      "question_uuid": "food_pickup",
      "type": "compound",
      "label": "food_pickup",
      "questions": [
        {
          "question_uuid": "pick_up_name",
          "type": "string",
          "label": "fragment_profile_edittext_pickupname",
          "validations": [
            {
              "name": "required",
              "argument": true,
              "error_label": "aiq_validation_error_required_pick_up_name"
            }
          ]
        },
        {
          "question_uuid": "pick_up_phone",
          "type": "telephone_us",
          "label": "fragment_profile_edittext_pickupphone"
        }
      ]
    },
    {
      "question_uuid": "relationship_status",
      "type": "select_one",
      "label": "relationship_status",
      "options": [
        {
          "label": "relationship_status_option_single",
          "value": "single"
        },
        {
          "label": "relationship_status_option_domestic_partner",
          "value": "domestic_partner"
        },
        {
          "label": "relationship_status_option_common_law",
          "value": "common_law"
        },
        {
          "label": "relationship_status_option_emancipated_minor",
          "value": "emancipated_minor"
        },
        {
          "label": "relationship_status_option_married",
          "value": "married"
        },
        {
          "label": "relationship_status_option_divorced",
          "value": "divorced"
        },
        {
          "label": "relationship_status_option_separated",
          "value": "separated"
        },
        {
          "label": "relationship_status_option_widowed",
          "value": "widowed"
        }
      ]
    },
    {
      "question_uuid": "housing",
      "type": "select_one",
      "label": "housing_status",
      "options": [
        {
          "label": "housing_option_own",
          "value": "own"
        },
        {
          "label": "housing_option_room_in_apartment",
          "value": "room_in_apartment"
        },
        {
          "label": "housing_option_friends_or_family",
          "value": "friends_or_family"
        },
        {
          "label": "housing_option_regular_rent",
          "value": "regular_rent"
        },
        {
          "label": "housing_option_subsidized_rent",
          "value": "subsidized_rent"
        },
        {
          "label": "housing_option_shelter",
          "value": "shelter"
        },
        {
          "label": "housing_option_homeless",
          "value": "homeless"
        }
      ]
    },
    {
      "question_uuid": "education",
      "type": "select_one",
      "label": "highest_education_obtained",
      "options": [
        {
          "label": "education_option_no_high_school",
          "value": "no_high_school"
        },
        {
          "label": "education_option_high_school_diploma",
          "value": "high_school_diploma"
        },
        {
          "label": "education_option_ged",
          "value": "ged"
        },
        {
          "label": "education_option_associate_or_bachelo",
          "value": "associate_or_bachelo"
        },
        {
          "label": "education_option_post_graduate",
          "value": "post_graduate"
        }
      ]
    },
    {
      "question_uuid": "ethnicity",
      "type": "select_one",
      "label": "ethnicity",
      "options": [
        {
          "label": "ethnicity_option_two_or_more_races",
          "value": "two_or_more_races"
        },
        {
          "label": "ethnicity_option_black",
          "value": "black"
        },
        {
          "label": "ethnicity_option_white",
          "value": "white"
        },
        {
          "label": "ethnicity_option_hispanic_or_latino",
          "value": "hispanic_or_latino"
        },
        {
          "label": "ethnicity_option_asian_or_pacific",
          "value": "asian_or_pacific"
        },
        {
          "label": "ethnicity_option_american_indian_or_alaskan",
          "value": "american_indian_or_alaskan"
        },
        {
          "label": "ethnicity_option_other",
          "value": "other"
        }
      ]
    },
    {
      "question_uuid": "needs_assistance",
      "type": "boolean",
      "label": "needs_assistance",
      "options": [
        {
          "label": "needs_assistance",
          "value": 1
        },
        {
          "label": "dont_need_assistance",
          "value": 0
        }
      ]
    },
    {
      "question_uuid": "birth_date",
      "type": "date",
      "label": "dob_required",
      "validations": [
        {
          "name": "required",
          "argument": true,
          "error_label": "aiq_validation_error_required_birth_date"
        }
      ]
    },
    {
      "question_uuid": "zip_code",
      "type": "zip_code",
      "label": "app_personal_edittext_zipcode",
      "validations": [
        {
          "name": "regex",
          "argument": "^\\d{5}$",
          "error_label": "aiq_validation_error_regex_zip_code"
        }
      ]
    },
    {
      "question_uuid": "first_name",
      "type": "text",
      "label": "app_personal_edittext_firstname",
      "validations": [
        {
          "name": "required",
          "argument": true,
          "error_label": "aiq_validation_error_required_first_name"
        }
      ]
    },
    {
      "question_uuid": "last_name",
      "type": "text",
      "label": "app_personal_edittext_lastname",
      "validations": [
        {
          "name": "required",
          "argument": true,
          "error_label": "aiq_validation_error_required_last_name"
        }
      ]
    },
    {
      "question_uuid": "baby_supplies",
      "type": "number",
      "validations": [
        {
          "name": "min",
          "argument": 0,
          "error_label": "aiq_validation_error_min_baby_supplies"
        },
        {
          "name": "max",
          "argument": 11,
          "error_label": "aiq_validation_error_max_baby_supplies"
        }
      ],
      "label": "baby_supplies"
    },
    {
      "question_uuid": "dietary_preferences",
      "type": "select_multiple",
      "label": "custom_field_dietary_preferences",
      "options": [
        {
          "label": "dietary_preferences_option_none",
          "value": "none"
        },
        {
          "label": "dietary_preferences_option_lactose",
          "value": "lactose"
        },
        {
          "label": "dietary_preferences_option_gluten",
          "value": "gluten"
        },
        {
          "label": "dietary_preferences_option_kosher",
          "value": "kosher"
        },
        {
          "label": "dietary_preferences_option_halal",
          "value": "halal"
        },
        {
          "label": "dietary_preferences_option_dairy_free",
          "value": "dairy_free"
        },
        {
          "label": "dietary_preferences_option_vegetarian",
          "value": "vegetarian"
        },
        {
          "label": "dietary_preferences_option_vegan",
          "value": "vegan"
        },
        {
          "label": "dietary_preferences_option_fodmap",
          "value": "fodmap"
        },
        {
          "label": "dietary_preferences_option_nut_allergy",
          "value": "nut_allergy"
        }
      ]
    },
    {
      "question_uuid": "address",
      "type": "address_us",
      "label": "address"
    },
    {
      "question_uuid": "contact_info",
      "type": "telephone_us",
      "label": "app_personal_edittext_phone"
    },
    {
      "question_uuid": "employment",
      "type": "select_one",
      "label": "employment",
      "options": [
        {
          "value": "full_time",
          "label": "employment_option_full_time"
        },
        {
          "value": "part_time",
          "label": "employment_option_part_time"
        },
        {
          "value": "unemployed",
          "label": "employment_option_unemployed"
        }
      ]
    }
  ]
}
